/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comma-, tab- or space-separated rows of x, y and size, with an optional all-text header row.`)
};

const es_bubble_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas de x, y y tamaño separadas por comas, tabulaciones o espacios, con una fila de cabecera opcional totalmente de texto.`)
};

const de_bubble_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durch Kommas, Tabulatoren oder Leerzeichen getrennte Zeilen aus x, y und Größe, mit einer optionalen reinen Text-Kopfzeile.`)
};

const nl_bubble_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komma-, tab- of spatiegescheiden rijen van x, y en grootte, met een optionele headerrij die volledig uit tekst bestaat.`)
};

const fr_bubble_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des lignes de x, y et taille séparées par des virgules, des tabulations ou des espaces, avec une ligne d'en-tête entièrement textuelle optionnelle.`)
};

const it_bubble_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righe di x, y e dimensione separate da virgole, tabulazioni o spazi, con una riga di intestazione opzionale interamente testuale.`)
};

const pt_br2_bubble_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas de x, y e tamanho separadas por vírgula, tabulação ou espaço, com uma linha de cabeçalho totalmente textual opcional.`)
};

const pt_bubble_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas de x, y e tamanho separadas por vírgulas, tabulações ou espaços, com uma linha de cabeçalho opcional totalmente textual.`)
};

const ja_bubble_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`x、y、サイズをカンマ、タブ、またはスペース区切りにした行で、任意の全文字ヘッダー行にも対応しています。`)
};

const zh_bubble_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以逗号、制表符或空格分隔的 x、y、size 行，可选一行全文本的表头。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_faq_a3", locale)
	if (locale === "en") return en_bubble_faq_a3(inputs)
	if (locale === "es") return es_bubble_faq_a3(inputs)
	if (locale === "de") return de_bubble_faq_a3(inputs)
	if (locale === "nl") return nl_bubble_faq_a3(inputs)
	if (locale === "fr") return fr_bubble_faq_a3(inputs)
	if (locale === "it") return it_bubble_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_faq_a3(inputs)
	if (locale === "pt") return pt_bubble_faq_a3(inputs)
	if (locale === "ja") return ja_bubble_faq_a3(inputs)
	return zh_bubble_faq_a3(inputs)
};